module.exports = __webpack_public_path__ + "static/img/magicBaySuccess.d57b7e2.png";